import React from 'react';
import * as yup from 'yup';
import { Formik } from 'formik';
import { useHistory } from 'react-router-dom';
import { StatusCodes } from 'http-status-codes';

import WhitePad from '../../../../components/common/WhitePad/WhitePad';
import HsCodesApi from '../../../../services/api/HsCodesApi';
import FormRow from '../../../../components/common/forms/Row/FormRow';
import TextInputComponent from '../../../../components/common/forms/TextInput/TextInputComponent';
import PrimaryButton from '../../../../components/common/forms/Button/PrimaryButton';
import TitleComponent from '../../../../components/common/forms/Title/TitleComponent';
import FormWrapper from '~/src/components/common/forms/FormWrapper/FormWrapper';
import TextAreaComponent from '~/src/components/common/forms/TextInput/TextAreaComponent';

const validationSchema = yup.object().shape({
  code: yup.string().label('Code').min(2, 'Code should be at least 2 symbols').required('Code is required'),
  nameEn: yup
    .string()
    .label('Name English')
    .min(2, 'NameEn should be at least 2 symbols')
    .required('NameEn is required'),
  nameBg: yup
    .string()
    .label('Name Bulgarian')
    .min(2, 'NameBg should be at least 2 symbols')
    .required('NameBg is required'),
});

export default function HsCodeCreate(): React.ReactElement {
  const history = useHistory();

  const saveItem = async (values, setSubmitting) => {
    setSubmitting(true);
    const res = await HsCodesApi.create(values);
    if (res.status === StatusCodes.OK) {
      history.push('/hsCodes');
    } else {
      setSubmitting(false);
    }
  };

  return (
    <WhitePad>
      <TitleComponent
        title="Create Hs Code"
        onLeftHandler={() => {
          history.goBack();
        }}
        titleLeft="Back"
      />
      <FormWrapper>
        <Formik
          initialValues={{
            code: '',
            nameEn: '',
            nameBg: '',
          }}
          validationSchema={validationSchema}
          onSubmit={(values, { setSubmitting }) => saveItem(values, setSubmitting)}
        >
          {({ values, handleChange, handleBlur, handleSubmit, isSubmitting, touched, errors }) => (
            <form onSubmit={handleSubmit} autoComplete="off">
              <FormRow>
                <TextInputComponent
                  label="Code"
                  name="code"
                  value={values.code}
                  onBlur={handleBlur}
                  onChange={handleChange}
                  cols={12}
                />
              </FormRow>
              <FormRow>
                <TextAreaComponent
                  name="nameEn"
                  value={values.nameEn}
                  onBlur={handleBlur}
                  onChange={handleChange}
                  touched={touched}
                  errors={errors}
                  cols={12}
                  rows={6}
                />
              </FormRow>
              <FormRow>
                <TextAreaComponent
                  name="nameBg"
                  value={values.nameBg}
                  onBlur={handleBlur}
                  onChange={handleChange}
                  touched={touched}
                  errors={errors}
                  cols={12}
                  rows={6}
                />
              </FormRow>
              <PrimaryButton isSubmitting={isSubmitting} type="submit" title="Save" />
            </form>
          )}
        </Formik>
      </FormWrapper>
    </WhitePad>
  );
}
